var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"rules":_vm.rules,"label":_vm.$t('common.input_mailaddress-label'),"placeholder":_vm.form.placeholder,"outlined":""},model:{value:(_vm.setEmail),callback:function ($$v) {_vm.setEmail=$$v},expression:"setEmail"}})}
var staticRenderFns = []

export { render, staticRenderFns }